import Editor from "../../../form/Editor";
import FileUploadSingle from "../../../form/FileUploadSingle";
import Input from "../../../form/Input";
import Textarea from "../../../form/Textarea";

export const ApplyPageForm = ({
  values,
  handleChange,
  errors,
  formValidate,
}) => (
  <div className="grid grid-cols-12 gap-4">
    <div className="relative col-span-6 space-y-3">
      <Input
        label="Eligibility Title"
        inputPlaceholder="Enter Eligibility Title"
        inputName="eligibilityTitle"
        value={values?.eligibilityTitle || ""}
        onChange={handleChange}
        {...formValidate(errors, "eligibilityTitle")}
      />
      <FileUploadSingle
        label={"Eligibility Sub Image"}
        labelClasses={"!mb-2"}
        value={values?.eligibilityImage}
        onChange={(file) =>
          handleChange({ target: { name: "eligibilityImage", value: file } })
        }
        {...formValidate(errors, "eligibilityImage")}
      />
    </div>
    <div className="relative col-span-6">
      <Editor
        label="Eligibility Description"
        placeholder="Enter Eligibility Description"
        value={values?.eligibilityDesc}
        onChange={(val) =>
          handleChange({
            target: { name: "eligibilityDesc", value: val },
          })
        }
        {...formValidate(errors, "eligibilityDesc")}
      />
      <Editor
        label="Eligibility Sub-Title"
        placeholder="Enter Eligibility Title"
        value={values?.eligibilitySubTitle}
        onChange={(val) =>
          handleChange({
            target: { name: "eligibilitySubTitle", value: val },
          })
        }
        {...formValidate(errors, "eligibilitySubTitle")}
      />
    </div>
    <div className="relative col-span-6 space-y-3">
      <Input
        label="Timeline Title"
        inputPlaceholder="Enter Timeline Title"
        inputName="timelineTitle"
        value={values?.timelineTitle || ""}
        onChange={handleChange}
        {...formValidate(errors, "timelineTitle")}
      />
      <FileUploadSingle
        label={"Timeline Sub Image"}
        labelClasses={"!mb-2"}
        value={values?.timelineImage}
        onChange={(file) =>
          handleChange({ target: { name: "timelineImage", value: file } })
        }
        {...formValidate(errors, "timelineImage")}
      />
    </div>
    <div className="relative col-span-6">
      <Editor
        label="Timeline Description"
        placeholder="Enter Timeline Description"
        value={values?.timelineDesc}
        onChange={(val) =>
          handleChange({
            target: { name: "timelineDesc", value: val },
          })
        }
        {...formValidate(errors, "timelineDesc")}
      />
    </div>
    <div className="relative col-span-6">
      <Input
        label="FAQ Title"
        inputPlaceholder="Enter FAQ Title"
        inputName="faqTitle"
        value={values?.faqTitle || ""}
        onChange={handleChange}
        {...formValidate(errors, "faqTitle")}
      />
    </div>
    <div className="relative col-span-6">
      <FileUploadSingle
        label={"FAQ Sub Image"}
        labelClasses={"!mb-2"}
        value={values?.faqImage}
        onChange={(file) =>
          handleChange({ target: { name: "faqImage", value: file } })
        }
        {...formValidate(errors, "faqImage")}
      />
    </div>
  </div>
);
